import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { Button } from 'reactstrap';

const LinkButton = ({ text, to, isExternal, style }) => {
  if (isExternal) {
    return (
      <a href={to} target="_blank">
        <StyledButton>{text}</StyledButton>
      </a>
    );
  }
  return (
    <StyledButton tag={Link} to={to}>
      {text}
    </StyledButton>
  );
};

LinkButton.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  isExternal: PropTypes.bool,
};

// inline Component to "Style" the button (with hover)
class StyledButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };

    this.toggleHover = this.toggleHover.bind(this);
  }

  toggleHover() {
    this.setState({ hover: !this.state.hover });
  }

  render() {
    const { children } = this.props;
    const { hover } = this.state;

    let hoverStyle;
    if (hover) {
      hoverStyle = {
        backgroundColor: 'lightblue',
        borderColor: 'lightblue',
      };
    }

    return (
      <Button
        style={{
          backgroundColor: '#1EAAE5',
          borderColor: '#1EAAE5',
          ...hoverStyle,
        }}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
      >
        {children}
      </Button>
    );
  }
}

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/LinkButton.js